import { Component, OnInit } from '@angular/core';
import { IFilterAngularComp } from 'ag-grid-angular';
import { IDoesFilterPassParams, IFilterParams } from 'ag-grid-community';

@Component({
  selector: 'app-app-name-filter',
  templateUrl: './app-name-filter.component.html',
  styleUrls: ['./app-name-filter.component.scss']
})
export class AppNameFilterComponent implements IFilterAngularComp {

  params: IFilterParams;
  filterText = '';


  destroySubscription = false;

  constructor() { }

  agInit(params: IFilterParams): void {
    this.params = params;
  }

  isFilterActive(): boolean {
    return this.filterText != null && this.filterText !== '';
  }

  doesFilterPass(params: IDoesFilterPassParams): boolean {
    const { node } = params;
    const nodeData = { node };
    // console.log(nodeData);
    const value = nodeData.node.data.app_name.toLowerCase();
    // console.log(value);
    // return this.filterText === value;
    return this.filterText
      .toLowerCase()
      .split(' ')
      .every((filterWord) => value.indexOf(filterWord) >= 0);
  }

  getModel() {
    if (!this.isFilterActive()) {
      return null;
    }

    return { value: this.filterText };
  }

  setModel(model: any) {
    this.filterText = model == null ? null : model.value;
  }

  onInputChanged(newValue: any) {
    this.params.filterChangedCallback();
  }

  destroy() {
    this.destroySubscription = true;
  }

}
